import { extend } from "flarum/common/extend";
import AdvPostComments from "../components/AdvPostComments";
import Advcomment from "../../common/models/Advcomment";
import PostAdvcomment from "../models/PostAdvcomment";
import CommentPost from "flarum/forum/components/CommentPost";
import Post from "flarum/common/models/Post";
import Model from "flarum/common/Model";

const ineligible = (post) => {
  return post.isHidden() || post.number() === 1 || !app.session.user;
};

export default function () {
  app.store.models.advcomments = Advcomment;
  app.store.models.post_advcomments = PostAdvcomment;
  Post.prototype.advcomments = Model.hasMany("advcomments");

  Advcomment.prototype.votes = Model.attribute('votes');
  Advcomment.prototype.canVote = Model.attribute('canVote');
  Advcomment.prototype.canSeeVotes = Model.attribute('canSeeVotes');
  Advcomment.prototype.hasUpvoted = Model.attribute('hasUpvoted');
  Advcomment.prototype.hasDownvoted = Model.attribute('hasDownvoted');

  extend(CommentPost.prototype, "footerItems", function (items) {
    const post = this.attrs.post;
    const postId = post.id();
    // console.log(post.number());
    // console.log(this.attrs.post.post_advcomments());

    if (ineligible(post)) return;

    items.add(
      "tolyod-advdiscus-comments",
      AdvPostComments.component({
        postId,
        post,
      })
    );
  });
};
